import { render } from "./lightbox_gallery.vue?vue&type=template&id=eb274f0e"
import script from "./lightbox_gallery.vue?vue&type=script&lang=js"
export * from "./lightbox_gallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__